import Vue from 'vue'
import Router from 'vue-router'
import routes from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'


Vue.use(Router)

const RouterLayout = createRouterLayout(layout => {
  return import('@/layouts/' + layout + '.vue')
})

export default new Router({
    mode: 'history',
  //base: location.pathname,
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
      }

  ]
})
